<template>
  <v-card class="mx-auto" max-width="980">
    <div class="pa-3 d-flex align-center">
      <h2>{{ title }}</h2>

      <v-spacer />
      <v-btn color="primary" icon @click="close">
        <v-icon large color="primary">mdi-close</v-icon>
      </v-btn>
    </div>

    <v-card class="mx-auto" max-width="980px">
      <v-icon class="d-flex-row justify-center pl-10 pt-3" large color="normalred"
        >mdi-account-outline</v-icon
      >
      <span class="titulo-detail" style="v-cardAdd">Informações do Produto:</span>

      <v-row class="pa-6 pt-0 pb-6 ma-0">
        <v-col cols="12" sm="6" md="6" lg="4">
          <div>
            <p class="label-details">Nome:</p>
            <span class="details-text">{{ this.currentProduct.productName }}</span>
          </div>
        </v-col>

        <v-col cols="12" sm="6" md="6" lg="4">
          <div>
            <p class="label-details">SKU:</p>
            <span class="details-text">{{ this.currentProduct.productSKU }}</span>
          </div>
        </v-col>

        <v-col cols="12" sm="6" md="6" lg="4">
          <div>
            <p class="label-details">EAN:</p>
            <span class="details-text">{{ this.currentProduct.productEAN }}</span>
          </div>
        </v-col>

        <v-col cols="12" sm="6" md="6" lg="4">
          <div>
            <p class="label-details">Aplicação:</p>
            <span class="details-text">{{ this.currentProduct.productApplication }}</span>
          </div>
        </v-col>

        <v-col cols="12" sm="6" md="6" lg="4">
          <div>
            <p class="label-details">Código:</p>
            <span class="details-text">{{ this.currentProduct.productCode }}</span>
          </div>
        </v-col>

        <v-col cols="12" sm="6" md="6" lg="4">
          <div>
            <p class="label-details">Tipo:</p>
            <span class="details-text">{{ this.currentProduct.productType }}</span>
          </div>
        </v-col>
      </v-row>
    </v-card>
    <v-card class="mx-auto" max-width="980px">
      <v-icon class="d-flex-row justify-center pl-10 pt-3" large color="normalred"
        >mdi-account-cog-outline</v-icon
      >
      <span class="titulo-detail" style="v-cardAdd">Status do produto:</span>

      <v-row class="pa-6 pt-0 pb-6 ma-0">
        <v-col cols="12" sm="6" md="6" lg="6">
          <div>
            <p class="label-details">
              Status do Produto:
              {{ this.currentProduct.status == "1" ? "Ativa" : "Inativa" }}
            </p>

            <v-select
              class="ma-0 pa-0"
              style="max-width: 160px; align-self: center; font-weight: bold"
              dense
              hide-details
              outlined
              :items="status"
              item-text="label"
              item-value="value"
              v-model="currentProduct.status"
              required
            >
            </v-select>
          </div>
        </v-col>

        <v-col cols="12" sm="6" md="6" lg="6">
          <div>
            <p class="label-details">Preço do produto:</p>
            <v-text-field outlined v-model="currentProduct.price" required></v-text-field>
          </div>
        </v-col>
      </v-row>
    </v-card>

    <v-card class="mx-auto" max-width="980px">
      <v-icon class="d-flex-row justify-center pl-10 pt-3" large color="normalred"
        >mdi-comment-eye-outline</v-icon
      >
      <span class="titulo-detail" style="v-cardAdd">Imagens do Produto:</span>

      <v-row class="d-flex justify-center pa-6 pt-0 pb-6 ma-0">
        <v-col cols="12" sm="12" md="8" lg="8">
          <v-carousel height="325">
            <v-carousel-item
              v-for="(src, i) in srcImages"
              :key="i"
              :src="env_url + src"
              reverse-transition="fade-transition"
              transition="fade-transition"
            ></v-carousel-item>
          </v-carousel>
        </v-col>
      </v-row>
    </v-card>
    <div>
      <v-row class="d-flex ma-0 pa-0">
        <v-col cols="12" class="d-flex justify-center">
          <!-- <v-btn
            large
            color="#2D3038"
            class="white--text"
            @click="close"
            :loading="loading"
          >
            <span>Voltar</span>
          </v-btn> -->

          <v-btn
            elevation="4"
            large
            color="normalred"
            class="white--text"
            @click="close()"
            :loading="loading"
          >
            <span>VOLTAR</span>
          </v-btn>
        </v-col>
      </v-row>
    </div>
  </v-card>
</template>

<style scoped>
@media (max-width: 600px) {
  .select-type {
    width: 90% !important;
  }
}

.form {
  display: flex;
  justify-content: center;
}

@media (max-width: 600px) {
  .form {
    flex-direction: column;
  }
}

.label-details {
  color: #232021;
  font-family: Roboto;
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 25px;
  margin: 0;
}

.details-text {
  color: #232021;
  font-family: Roboto;
  font-style: normal;
  font-size: 20px;
  line-height: 25px;
}

.titulo-detail {
  color: black;
  font-family: Roboto;
  font-style: normal;
  font-size: 20px;
  line-height: 40px;
  font-weight: bold;
}

/* .select{
  border: 1px solid #979797;
  box-sizing: border-box;
  border-radius: 10px;
} */
</style>

<script>
import ApiService from "../../../../services/ApiService";
import Vue from "vue";

export default {
  props: {
    title: String,
    product: Object,
  },

  created() {
    if (this.product) {
      this.isEditing = true;
      this.currentProduct = this.product;
      this.env_url = process.env.VUE_APP_BASE_URL;

      for (let i = 0; i < this.currentProduct.images.length; i++) {
        this.srcImages.push(this.currentProduct.images[i].path);
      }
      // this.money();
    }
  },

  data: () => ({
    env_url: "",
    srcImages: [],
    currentProduct: {},
    dialogKey: false,
    loading: false,
    step: 0,
    menu: false,
    error: false,
    isEditing: false,

    filter: {
      page: 1,
      pageSize: 15,
      DocumentNumber: null,
      Name: "",
      Cnpj: "",
      resalestatus: "",
      status: null,
      updated_at: null,
    },

    rules: {
      required: (value) => !!value || "Campo requerido.",

      min: (v) => v.length >= 4 || "Minimo de 4 caracteres.",
    },

    status: [
      { label: "Inativo", value: 0 },
      { label: "Ativo", value: 1 },
    ],
    apiService: new ApiService(),
  }),

  methods: {
    // money(){
    //   return this.currentProduct.price = this.currentProduct.price;
    // },

    close() {
      this.$emit("close");
    },

    action() {
      this.$emit("action");
    },

    async editStatus(currentProduct) {
      this.loading = true;

      this.currentProduct = currentProduct;

      await this.apiService
        .post(`resale/edit`, this.currentProduct)
        .then((resp) => {
          this.loading = false;

          Vue.$globalEvent.$emit("onFlashMessage", {
            type: "success",
            title: "Produto Editado com sucesso!",
            message: "Produto Editado com sucesso!",
            trace: null,
          });
        })
        .catch((erro) => {
          this.loading = false;
          Vue.$globalEvent.$emit("onFlashMessage", {
            type: "error",
            title: "Erro ao editar revenda",
            message: erro.body.message,
            trace: null,
          });
        });
    },
  },
};
</script>
